import Tooltip from 'react-tooltip-lite';
import { Progress } from 'reactstrap';
// import { useEWalletBalanceQuery } from '../../fund/src/fundQueries';
import { useEffect, useState } from 'react';
import CurrencyFormat from 'react-number-format';
import ContentLoader from '../../../components/ContentLoader';
import { useFundDispatch } from '../../../contexts/FundContext';
import { useDict } from '../../../contexts/LanguageContext';
import { getEWalletBalanceData } from '../src/investNowApis';

const InvestNowProfile = () => {
    const dict = useDict();

    const fundDispatch = useFundDispatch();

    const [isFetching, setIsFetching] = useState(false);
    const [eWalletBalanceData, setEWalletBalanceData] = useState(null);

    useEffect(() => {
        setIsFetching(true);
        getEWalletBalanceData(handleGetEWalletBalanceData);
        setIsFetching(false);
    }, []);

    const handleGetEWalletBalanceData = (response) => {
        setEWalletBalanceData(response.data.data);
    };

    const renderWithLoader = (component) => {
        if (isFetching) {
            return (
                <ContentLoader width="70" height="25" color="loader500">
                    <rect width="100%" height="100%" y="0" rx="4" ry="4" />
                </ContentLoader>
            );
        }

        return component;
    };

    return (
        <div className="investNow__summary">
            <div className="d-flex flex-column align-items-center mb-2 label-animation">
                <h5 className="text-white">
                    {dict.totalInvestment}
                    {/* <Tooltip
                        content="Expected return per annum"
                        styles={{ display: 'inline' }}
                        distance={5}
                        arrowSize={8}
                    >
                        <Icon icon="InfoCircle" inline width="11" />
                    </Tooltip> */}
                </h5>
                {renderWithLoader(
                    <CurrencyFormat
                        value={eWalletBalanceData?.invest || '0.00'}
                        displayType="text"
                        className="invest-now-currency-format"
                        thousandSeparator
                        prefix="฿ "
                    />
                    // <h3 className="text-white font-weight-bold">
                    //     {parseFloat(
                    //         eWalletBalanceData?.rate?.annual_rate || '0'
                    //     ).toFixed(1)}
                    //     %
                    // </h3>
                )}
            </div>
            <div className="d-flex flex-column align-items-center mb-2 label-animation">
                <h5 className="text-white">{dict.balance}</h5>
                {renderWithLoader(
                    <CurrencyFormat
                        value={eWalletBalanceData?.balance || '0.00'}
                        displayType="text"
                        className="invest-now-currency-format"
                        thousandSeparator
                        prefix="฿ "
                    />
                )}
            </div>
            <div className="d-flex flex-column align-items-center mb-2 label-animation">
                <h5 className="text-white">
                    {dict.totalWithdrawal}
                    {/* <Tooltip
                        content="Your principal lost over the principal invested by you"
                        styles={{ display: 'inline' }}
                        distance={5}
                        arrowSize={8}
                    >
                        <Icon icon="InfoCircle" inline width="11" />
                    </Tooltip> */}
                </h5>
                {renderWithLoader(
                    <CurrencyFormat
                        value={eWalletBalanceData?.withdrawal || '0.00'}
                        displayType="text"
                        className="invest-now-currency-format"
                        thousandSeparator
                        prefix="฿ "
                    />
                    // <h3 className="text-white font-weight-bold">
                    //     {parseFloat(
                    //         eWalletBalanceData?.rate?.default_rate || '0'
                    //     ).toFixed(1)}
                    //     %
                    // </h3>
                )}
            </div>
            <div className="d-flex flex-column align-items-center mb-2 label-animation">
                <h5 className="text-white">
                    {dict.transactionLimit}
                </h5>
                {renderWithLoader(
                    <div>
                        <Tooltip
                            content={`${eWalletBalanceData?.transactionLimitPercentage}%`}
                            direction="down"
                            distance={10}
                            arrowSize={5}
                        >
                            <CurrencyFormat
                                value={eWalletBalanceData?.transactionLimit || '0.00'}
                                displayType="text"
                                className="invest-now-currency-format"
                                thousandSeparator
                                prefix="฿ "
                            />
                            &nbsp;/฿ 1M
                            <Progress
                                striped={false}
                                color="warning"
                                className="transaction-limit-progress-bar"
                                value={eWalletBalanceData?.transactionLimitPercentage}
                            />
                        </Tooltip>
                    </div>
                )}
            </div>
        </div>
    );
};

export default InvestNowProfile;
